// extracted by css-extract-rspack-plugin
export default {"cls1":"CourseResults-cls1_Kgt","cls2":"CourseResults-cls2_6sZ CourseResults-cls1_Kgt"};